import React from 'react'
import Navbar from './NavBar'
import Footer from './Footer'

const AboutUs = () => {
    return (
        <div>
            <Navbar />
            <div className="container mx-auto px-4 py-8">
                <h1 className="text-3xl font-bold text-center mb-8">About Us</h1>
                
                <div className="max-w-4xl mx-auto space-y-6">
                    <div className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">Our Story</h2>
                        <p className="text-gray-700">
                            We are passionate about delivering exceptional products and services to our customers. 
                            Founded in [year], we've been committed to innovation and excellence in everything we do.
                        </p>
                    </div>

                    <div className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
                        <p className="text-gray-700">
                            Our mission is to provide high-quality solutions while maintaining the highest standards 
                            of customer service and professional excellence.
                        </p>
                    </div>

                    <div className="mb-8">
                        <h2 className="text-2xl font-semibold mb-4">Our Values</h2>
                        <ul className="list-disc list-inside text-gray-700 space-y-2">
                            <li>Customer Satisfaction</li>
                            <li>Innovation</li>
                            <li>Integrity</li>
                            <li>Excellence</li>
                            <li>Teamwork</li>
                        </ul>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                        <h2 className="text-2xl font-semibold mb-4">Why Choose Us?</h2>
                        <div className="grid md:grid-cols-2 gap-4">
                            <div>
                                <h3 className="font-semibold mb-2">Experience</h3>
                                <p className="text-gray-700">Years of industry experience delivering quality solutions</p>
                            </div>
                            <div>
                                <h3 className="font-semibold mb-2">Support</h3>
                                <p className="text-gray-700">24/7 customer support to assist you</p>
                            </div>
                            <div>
                                <h3 className="font-semibold mb-2">Quality</h3>
                                <p className="text-gray-700">Commitment to delivering excellence</p>
                            </div>
                            <div>
                                <h3 className="font-semibold mb-2">Innovation</h3>
                                <p className="text-gray-700">Always staying ahead with latest technologies</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default AboutUs